import { render, staticRenderFns } from "./VertragStornierenModal.vue?vue&type=template&id=654fb4b4&"
import script from "./VertragStornierenModal.vue?vue&type=script&lang=js&"
export * from "./VertragStornierenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports